
import {
  createReducer,
  on
} from '@ngrx/store';
import { SharedActions } from '../actions/action-types';

export const sharedFeatureKey = 'sharedConfig';

export interface SharedState {
  config_details:any,
  header_brands_list:any
}

export const initialSharedState:SharedState = {
  config_details:{},
  header_brands_list:{}
}


export const sharedReducer = createReducer(
  initialSharedState,
  on(SharedActions.configDetails,(state:any,action:any)=>{
    return{
      ...state,
      config_details:action.config_details
    }
  }),
  on(SharedActions.brandListing,(state:any,action:any)=>{
    return{
      ...state,
      header_brands_list:action.header_brands_list
    }
  }),
)

